import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  configFieldOptionsSelector,
  configFieldSelector,
  fetchConfigFields,
} from 'slices/examInCoreSettings.slice';
import {
  objectExtTypesSelector,
  situationsSelector,
} from 'slices/reservationSettings.slice';
import { useAppDispatch } from 'slices/store';
import { Col, Row } from '@timeedit/ui-components/antd';
import ExamInCoreConfigurationDropdown from './ExamInCoreConfigurationDropdown';
import {
  EXAM_CONFIGURATION_FIELD_MODE,
  EXAM_CONFIG_FIELD_DROPDOWN_TYPE,
  renderDefaultSelectField,
} from './helpers';
import './ExamInCoreConfiguration.scss';

type ConfigFieldItemProps = {
  label: string;
  config: string;
  className: string;
  handleConfigureField: ({ config, type, value }: any) => void;
};

const ConfigFieldItem = ({
  label,
  config,
  className,
  handleConfigureField,
}: ConfigFieldItemProps) => {
  const dispatch = useAppDispatch();
  const situations = useSelector(situationsSelector);
  const objectExtTypes = useSelector(objectExtTypesSelector);
  const configFieldValue = useSelector(configFieldSelector(config));
  const configFieldOptions = useSelector(configFieldOptionsSelector(config));

  useEffect(() => {
    dispatch(
      fetchConfigFields({
        config,
        object: configFieldValue.mode,
      })
    );
  }, [configFieldValue, dispatch, config]);

  const modeDropdownOptions = useMemo(() => {
    return configFieldValue.source ===
      EXAM_CONFIGURATION_FIELD_MODE.OBJECT_TYPES
      ? objectExtTypes
      : situations;
  }, [configFieldValue.source, objectExtTypes, situations]);

  return (
    <Row gutter={16} className={className}>
      <Col span={3}>
        <p>{label}:</p>
      </Col>
      <Col span={7}>
        <ExamInCoreConfigurationDropdown
          type={EXAM_CONFIG_FIELD_DROPDOWN_TYPE.SOURCE}
          config={config}
          options={renderDefaultSelectField}
          value={configFieldValue.source}
          onChangeDropdown={handleConfigureField}
        />
      </Col>
      <Col span={7}>
        <ExamInCoreConfigurationDropdown
          type={EXAM_CONFIG_FIELD_DROPDOWN_TYPE.MODE}
          config={config}
          value={configFieldValue.mode}
          onChangeDropdown={handleConfigureField}
          options={modeDropdownOptions}
        />
      </Col>
      <Col span={7}>
        <ExamInCoreConfigurationDropdown
          type={EXAM_CONFIG_FIELD_DROPDOWN_TYPE.FIELD}
          config={config}
          value={configFieldValue.field}
          onChangeDropdown={handleConfigureField}
          options={configFieldOptions}
        />
      </Col>
    </Row>
  );
};
export default ConfigFieldItem;
